module.exports = __webpack_public_path__ + "static/media/menu-outline.c64f9d2b.svg";